import PropTypes from 'prop-types';
import React from 'react';
import SvgIcon from './SvgIcon';

const SvgShadow = props => (
    <SvgIcon
        role="img"
        focusable="false"
        aria-hidden="true"
        ariaLabelledBy={props.ariaLabelledBy}
        ariaDescribedBy={props.ariaDescribedBy}
        class={`svg-${props.type}-shadow lantern-svg`}
        id={props.id}
    />
);

SvgShadow.propTypes = {
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    ariaLabelledBy: PropTypes.string,
    ariaDescribedBy: PropTypes.string,
};
SvgShadow.defaultProps = {
    ariaLabelledBy: '',
    ariaDescribedBy: '',
};

export default SvgShadow;
